import { AnyAction } from 'redux';
import { AUTH_ACTIONS } from '../actions/auth';
import { ModuleType } from '../types';
import { AuthState } from '../types/state';

const initialState: AuthState = {
  isAuthenticated: false,
  clientState: 3,
  tokenValid: true,
  managedProperties: [],
  portfolioType: 'MF',
  validatingAuthToken: false,
  entrataUserSignupData: undefined,
  emailLink: false,
  isLoading: false,
  modules: [], //['dashboard', 'renewals', 'portfolio-manager', 'reports'],
};

const loginReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case AUTH_ACTIONS.EMAIL_SIGNIN_LINK_LOGIN_ERROR:
    case AUTH_ACTIONS.EMAIL_SIGNIN_LINK_CREATE_FAIL:
    case AUTH_ACTIONS.LOGIN_ERROR: {
      return Object.assign({}, state, {
        isAuthenticated: false,
        loginError: action.payload.error,
      });
    }
    case AUTH_ACTIONS.IS_LOADING:
      return Object.assign({}, state, {
        isLoading: action.payload,
      });
    case AUTH_ACTIONS.LOGIN_SUCCESS:
    case AUTH_ACTIONS.RESET_PASSWORD_SUCCESS:
    case AUTH_ACTIONS.EMAIL_SIGNIN_LINK_LOGIN_SUCCESS:
    case AUTH_ACTIONS.VAlIDATE_AUTH_TOKEN_SUCESS: {
      const { modules, ...user } = action.payload;
      let uiModules = modules.map((ele: any) => {
        return {
          Title: ele.Title,
          Icon: ele.Icon,
          Name: ele.Title,
          Path: ele.Path,
          IsActive: true,
        } as ModuleType;
      });
      return Object.assign({}, state, {
        isAuthenticated: true,
        ...user,
        modules: uiModules,
        resetError: undefined,
        loginError: undefined,
        forgotError: undefined,
      });
    }
    case AUTH_ACTIONS.VALIDATING_TOKEN: {
      return Object.assign({}, state, { validating: action.payload });
    }
    case AUTH_ACTIONS.VALIDATE_TOKEN_SUCCESS: {
      return Object.assign({}, state, { tokenValid: true });
    }
    case AUTH_ACTIONS.VALIDATE_TOKEN_FAIL: {
      return Object.assign({}, state, { tokenValid: false });
    }
    case AUTH_ACTIONS.FORGOT_PASSWORD_ERROR: {
      return Object.assign({}, state, { forgotError: action.payload.error });
    }
    case AUTH_ACTIONS.RESET_PASSWORD_ERROR: {
      return Object.assign({}, state, { resetError: action.payload.error });
    }
    case AUTH_ACTIONS.LOGOUT: {
      return Object.assign({}, state, {
        isAuthenticated: false,
        loginError: undefined,
        forgotError: undefined,
        resetError: undefined,
      });
    }
    case AUTH_ACTIONS.VALIDATING_AUTH_TOKEN: {
      return Object.assign({}, state, { validatingAuthToken: action.payload });
    }
    case AUTH_ACTIONS.FORGOT_PASSWORD_SUCCESS: {
      return Object.assign({}, state, {
        forgotPassSuccess: true,
        forgotError: undefined,
      });
    }
    case AUTH_ACTIONS.SIGNUP_ENTRATA_USER: {
      return Object.assign({}, state, {
        entrataUserSignupData: action.payload,
      });
    }
    case AUTH_ACTIONS.EMAIL_SIGNIN_LINK_CREATE_SUCCESS: {
      return { ...state, emailLink: true };
    }
    case AUTH_ACTIONS.EMAIL_SIGNIN_LINK_RESET: {
      return { ...state, emailLink: false };
    }
    case AUTH_ACTIONS.GET_LINKED_CLIENTS: {
      return Object.assign({}, state, {
        linkedClients: action.payload,
      });
    }
    case AUTH_ACTIONS.GET_CURRENT_CLIENT: {
      return Object.assign({}, state, {
        currentClient: action.payload,
      });
    }
    case AUTH_ACTIONS.INITIALIZE:
    default: {
      return state;
    }
  }
};
export default loginReducer;
